
<template>
 <q-page class="row" >
     <div class="bg-white" style="border-radius: 1rem !important; position: fixed !important; background: #fff !important; width: 100% !important; z-index: 10 !important;">
            <div class="q-px-lg q-py-sm col-xs-12 col-md-9" style="background-color: #feecf0 !important; color: #cc0f35 !important;">
                <timer ref="timer"/>
            </div>
        </div>
     <div class="col-xs-12 col-md-9 q-px-lg" style="margin: auto; padding-bottom: 78px;">
       
        <!-- for normal/tablet web view -->
         <div class="col gt-xs marginTopContent">
        <q-stepper  id="invStepper" ref="stepper" v-model="step"  color="primary" animated alternative-labels contractable class="no-shadow" style="border-radius: 1rem;">
            <q-step icon="settings" class="QStepHead" :done="step > 1"  name="1" prefix="1" :title='$t("stepper.title4")'>
                <q-form class="q-pa-sm">
                    <TransactionBuy></TransactionBuy>
                </q-form>
            </q-step>
            <q-step icon="message"  class="QStepHead" :done="step > 2"  name="2" prefix="2" :title='$t("stepper.title5")'>
                <q-form class="q-pa-sm">
                    <TAC></TAC>
                </q-form>
            </q-step>
            <q-step  icon="assignment_turned_in"  class="QStepHead" :done="step > 4" prefix="3"  name="4" :title='$t("stepper.title11")'>
                <q-form class="q-pa-sm">
                    <ACK/>
                </q-form>
            </q-step>
        </q-stepper>
        </div>
        <!-- for normal/tablet web view -->

         <!-- for phone web view -->
         <div class="col lt-sm" style="margin-top: 68px !important;">
        <q-stepper ref="stepper" vertical v-model="step"  color="primary" animated alternative-labels contractable class="no-shadow" style=" border-radius: 1rem;">
            <q-step icon="settings" class="QStepHead" :done="step > 1"  name="1" prefix="1" :title='$t("stepper.title4")'>
                <q-form class="q-pa-sm">
                    <TransactionBuy></TransactionBuy>
                </q-form>
            </q-step>
            <q-step icon="message"  class="QStepHead" :done="step > 2"  name="2" prefix="2" :title='$t("stepper.title5")'>
                <q-form class="q-pa-sm">
                    <TAC></TAC>
                </q-form>
            </q-step>
            <q-step  icon="assignment_turned_in"  class="QStepHead" :done="step > 4" prefix="3"  name="4" :title='$t("stepper.title11")'>
                <q-form class="q-pa-sm">
                    <ACK/>
                </q-form>
            </q-step>
        </q-stepper>
        </div>
         <!-- for phone web view -->

           <q-dialog v-model="userAlert"  persistent transition-show="scale" transition-hide="scale">
                <q-card style="min-width:30vw;max-width:80vw">
                <q-card-section>
                     Hi There!
                </q-card-section>
                  <q-card-section>
                      <div class="row">
                          <div class="col">
                              Please key in your mobile number for TAC purpose
                          </div>
                          <div class="col">
                              <q-input
                                    filled
                                    v-model="StoreStateAO.ContactInformation.MobileNo"
                                    label="Phone"
                                    mask="##########"
                                    hint=": ##########"
                                />
                          </div>
                      </div>
                </q-card-section>
                <q-card-section>
                     <Navigation
                        class="q-px-sm"
                        :ShowConfirmButton=true
                        ConfirmButtonColor="primary"
                        @ConfirmButton="Confirmed()"
                    />
                </q-card-section>
                </q-card>
           </q-dialog>
     </div>

        <q-dialog v-model="requestUpdateAlert"  persistent transition-show="scale" transition-hide="scale">
            <q-card class="my-card" style="max-width:30vw">
            <q-card-section  class="bg-warning text-white text-body1">
                    Hi {{StoreStateAO.PersonalInformation.FullName}},
            </q-card-section>
                <q-form   class="q-gutter-md" @submit="onSubmit">
                    <q-card-section>
                        <UpdateRequest/>  
                    </q-card-section>
                
                
            <q-card-actions align="right" >
                <q-btn label="Update" color="primary" text-color="white" type="submit" />
            </q-card-actions>
            </q-form>
            </q-card>
        </q-dialog>
    </q-page>
</template>
<style>

</style>

<style>
.QStepHead{
    cursor: default;
}
@media screen and (max-width: 768px){    
    .q-stepper__header.row.items-stretch.justify-between.q-stepper__header--standard-labels.q-stepper__header--border {
        display: none;
    }
    .marginTopContent{
        margin-top: 95px !important;
    }
}

.stepTitle{
    font-size: 16px;
    border-bottom: 1px solid #d7d7d7;
    position: fixed;
    background: rgb(255 255 255 / 99%);
    z-index: 10;
    width: 100%;
    transform: translate3d(-24px, -83px, 0px);
    text-align: center;
    backdrop-filter: blur(3px);
}
@media screen and (min-width: 769px){
    .stepTitle{
        display: none !important;
    }
    .marginTopContent{
        margin-top: 68px;
    }
}

.stepIndex{
    border-radius: 100%; background: #9e9e9e; color: white; height: 22px; width: 22px; padding: 1px 7px; font-size: 14px;
}

/* space stepper between header and body */
div#invStepper {
    background: transparent !important;
}

</style>
<script>

import timer from '@/components/timer'
import { mapActions } from 'vuex';
import ACK from '@/components/Acknowledgement.vue'
import TAC from '@/components/TAC.vue'
import Declaration from '@/components/Declaration.vue'
import Navigation from '@/components/NavigationButtons'
import AC from '@/components/ApplicantCredentials.vue'
import AD from '@/components/ApplicantDetails.vue'
import FATCA from '@/components/FATCA.vue'
import ED from "@/components/EmploymentDetails.vue";
import Summary from "@/views/SummaryAccountOpening.vue"
import TransactionBuy from '@/views/TransactionsConfirmation.vue'
import UpdateRequest from '@/components/UpdateRequest.vue'
import store from '../store';
/* window.onbeforeunload = function() {
    return "You're leaving the site.";
}; */

import {
  Notify
  
} from 'quasar'
export default {
    name: 'LandingPage',
    components:{
        Navigation,    
        Declaration,
        AC,
        AD,
        ED,
        FATCA,
        TAC,
        ACK,
        Summary,
        TransactionBuy,
        UpdateRequest,        
        timer,
    },
    data(){
    return{
        //fatca
        StoreStateLookup : store.state.Lookup,
        StoreStateAD : store.state.AD,
        StoreStateFATCA : store.state.FATCA,
        StoreStateED : store.state.ED,
        StoreStateAO : store.state.AOD,
        StoreStateCD : store.state.CD,
        StoreStateTransaction : store.state.Transactions,
        StoreStateAPI : store.state.API,
        StoreStateLogin: store.state.Login,
        timeout: null,  
        step:'1',
        userAlert:false,
        requestUpdateAlert:false,
        IAkaunUrl : process.env.VUE_APP_IAKAUN_URL ,
        isIEBrowser: false,
    }
  }, 
   created() {
       store.commit('ResetToken')
        
        store.dispatch("ClearClientDetails")

        store.commit("ResetAODetails");
        store.commit("ResetState_ClientDetails");
        store.commit("ResetTransactionDetails");
        store.commit("ResetState_AD");

        
     var ua = window.navigator.userAgent; 
        var msie = ua.indexOf('MSIE '); 
        if (msie > 0) { 
          this.isIEBrowser = true;
            // IE 10 or older, return version number 
          this.BrowserType  = 'IE ' + parseInt(ua.substring( msie + 5, ua.indexOf('.', msie)), 10)
        } 
        var trident = ua.indexOf('Trident/'); 
        if (trident > 0) { 
            // IE 11, return version number 
          this.isIEBrowser = true;
          var rv = ua.indexOf('rv:'); 
          this.BrowserType ='IE ' + parseInt(ua.substring(   rv + 3, ua.indexOf('.', rv)), 10)
            
        } 
        var edge = ua.indexOf('Edge/'); 
        if (edge > 0) { 
          
            //Edge (IE 12+), return version number 
           this.isIEBrowser = true;
           this.BrowserType = 'IE ' + parseInt(ua.substring(   edge + 5, ua.indexOf('.', edge)), 10)
        }

      if(this.isIEBrowser === true){
         this.$q.dialog({
              title: 'Alert',
              message: "Hi, Our application is not supported in : "+this.BrowserType+". Best use in Google Chrome or Mozilla Firefox. You may continue by Copy and Paste the URL: https://investdev.affinhwangam.com" +
              this.StoreStateLogin.RouteToPath+" in Google Chrome or Mozilla Firefox"
          }).onOk(() => {
              this.triggerLogout();
          })   
     }
  },
  mounted(){
                  
    store.commit('ResetToken')
    store.commit("ResetAODetails");    
    store.commit("ResetState_ClientDetails");
    store.commit("ResetTransactionDetails");
    store.commit("ResetState_AD");
    
   
    let tempid = localStorage.getItem('Creation_uuid');
    this.StoreStateAD.Creation_uuid = tempid
    localStorage.clear();
    this.StoreStateTransaction.inComingTransaction = 'Investment'
    var url = new URL(window.location.href);
    var url_string = url.search;

    var appID = url.searchParams.get('appId');
    var LangToLoad = url.searchParams.get('language');

   //appID = '5714605c-e7e8-4535-91e8-8b34cd674d13'
   if(appID!=null){

        this.StoreStateLogin.incomingAppID = appID
        this.StoreStateLogin.LanguageToLoad = LangToLoad
    }
    //https://investdev.affinhwangam.com/buy?appId=e33de46a-6a85-49cd-a5fc-9864592e2e32&language=EN -->
    //https://investdev.affinhwangam.com/buy?appId=6d7a9f89-4b60-452c-932d-701605431be6&language=MS
   // appID='5714605c-e7e8-4535-91e8-8b34cd674d13'
  //appID = '05df6f46-362a-4b62-bf18-e5688d65f2cb'
  /// https://investdev.affinhwangam.com/buy?appId=54b5ee3a-2ec5-4435-acc8-4146ac7763b3&language=EN
  
 // https://investdev.affinhwangam.com/buy?appId=05df6f46-362a-4b62-bf18-e5688d65f2cb
 // https://investdev.affinhwangam.com/buy?appId=5714605c-e7e8-4535-91e8-8b34cd674d13
    if (this.StoreStateLogin.incomingAppID != undefined) {
        //move the whole function into this
         this.$q.loading.show({
                spinnerSize: 50
            }), 
            this.GetListOfFundBuy()
            .then(res => {
                if (res == true) {                  
                        this.GetEmisBuyApplication({
                            ApplicationId: this.StoreStateLogin.incomingAppID
                        })
                         .then(res => {
                            this.$store.dispatch('Logging',{
                           
                                appid : '2',
                                typeid :'4', 
                                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetEmisBuyApplication(Buy), ID Type -> ' + this.StoreStateAO.PersonalInformation.IdType + '. userID - > '+ userID
                            });

                             if (res == true) {
                                // this.GetListOfFundForOnboarding()
                                var userID = "";
                                if (this.StoreStateAO.PersonalInformation.IdType === 'NewIC') {
                                    userID = this.StoreStateAO.PersonalInformation.NRIC
                                } else {
                                    userID = this.StoreStateAO.PersonalInformation.OldID
                                }
                                this.GetCif({
                                    ApplicationId: userID
                                }).then(res => {

                                   /*  this.$store.dispatch('Logging',{
                           
                                        appid : '2',
                                        typeid :'4', 
                                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetCif (Buy), res : ' + res
                                    }); */
                                    
                                    if (res == true) {
                                        //|| (this.StoreStateAO.ContactInformation.MobileNo !=undefined) ||(this.StoreStateAO.ContactInformation.MobileNo != 'undefined')||||(this.StoreStateAO.ContactInformation.EmailAddress !=undefined)||(this.StoreStateAO.ContactInformation.EmailAddress != 'undefined')

                                        if((this.StoreStateAO.ContactInformation.MobileNo == '') || (this.StoreStateAO.ContactInformation.EmailAddress == '')){
                                                this.requestUpdateAlert = true;
                                                this.$q.loading.hide()
                                               
                                            }else{    
                                                this.TrnxCifCustomerInfo({
                                                        ApplicationId: userID
                                                    }).then(res=>{
                                                    this.$store.dispatch('Logging',{
                                                        appid : '2',
                                                        typeid :'4', 
                                                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'TrnxCifCustomerInfo (Buy), res : ' + res
                                                    });
                                                    if(res === true){
                                                        this.TimeInit();
                                                        if(this.StoreStateTransaction.Transaction.Investment.length > 0 ){
                                                            for(var i=0; i<this.StoreStateTransaction.Transaction.Investment.length; i++ ){
                                                                var fundCode = '';

                                                                this.getEmisDocumentDownloadLink({
                                                                    FundCode:this.StoreStateTransaction.Transaction.Investment[i].productCode
                                                                })
                                                            }
                                                        }
                                                        this.$q.loading.hide()
                                                    }else{
                                                        this.$q.dialog({
                                                            title: 'Message',
                                                            message: res,
                                                            persistent: true
                                                        }).onOk(() => { 
                                                            this.triggerLogout();
                                                        })
                                                        this.$q.loading.hide()
                                                    }
                                                })
                                                
                                                 /* this.GetLastServicingAgent()
                                                .then(res=>{

                                                    this.$store.dispatch('Logging',{
                                                        appid : '2',
                                                        typeid :'4', 
                                                        str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' GetLastServicingAgent (investment), ID Type -> ' + this.StoreStateAO.PersonalInformation.IdType + '. res - > '+  res
                                                    });
                                                        if(res === true){ */
                                                                //this.requestUpdateAlert = true;
                                                         
                                                 /*        }else{
                                                            this.$store.dispatch('Logging',{
                                                                appid : '2',
                                                                typeid :'4', 
                                                                str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + 'GetLastServicingAgent (investment), error ' //+ res
                                                            });
                                                            this.$q.dialog({
                                                                title: 'Error',
                                                                message : res
                                                            })
                                                            this.$q.loading.hide()
                                                        }
                                                }) */
                                               
                                            }
                                    } else {
                                        this.$q.dialog({
                                            title: 'Message',
                                            message: res,
                                            persistent: true
                                        }).onOk(() => {
                                        // console.log('OK')
                                            this.triggerLogout();
                                         })
                                        this.$q.loading.hide()
                                    }
                                })
                            }else if(res == false){
                                   /*  this.$q.dialog({
                                        title: 'Error',
                                        message: 'Sorry, API is not responding. Please retry or contact our admin for assistance.'
                                    }) */
                                this.$q.loading.hide()
                                this.$router.push({ name: 'Maintenance'});
                                
                            }else{
                                this.$q.dialog({
                                    title : 'Error',
                                    message : res,
                                    persistent : true,
                                    ok: 'Ok',
                                }).onOk(() => {
                                    // console.log('OK')
                                    this.triggerLogout();
                                })
                                this.$q.loading.hide()
                            }
                            
                         })
                
                    
                }else{
                    this.$q.loading.hide()
                    this.$router.push({ name: 'Maintenance'});
                }
            })  

    }else{
            this.$router.push({ name: 'Maintenance'});
        }
  
      //  this.userAlert = true
    //this.$store.dispatch('GetLookup');
  },
  methods:{
      ...mapActions([
            "GetEmisApplication",
            "GetLookup",
            //"GeteMisLookup",
            "GetCif",
            "TrnxCifCustomerInfo",
            "GetListOfFundForOnboarding",
            "GetListOfFundBuy",
            "GetEmisBuyApplication", 
            "triggerLogout",
            "CIFAccountInformationUpdate",
            "getEmisDocumentDownloadLink",
            "GetLastServicingAgent"
        ]),
        TimeInit() {
            var display = document.querySelector("#time");
            var duration = this.StoreStateAO.LandingPageTimer * 60
            // alert(" duration ->" + duration)
            // alert(" LandingPageTimer ->" + this.StoreStateAO.LandingPageTimer)

            if(0 == duration){
                this.$alert(this.$t("common.timeup"))
                .then( () => {

                window.location.href = this.IAkaunUrl 
                });
            } 
                var timer = duration,
                minutes,
                seconds;
                this.timeout = setInterval(() => {
                    minutes = parseInt(timer / 60, 10);
                    seconds = parseInt(timer % 60, 10);

                    minutes = minutes < 10 ? "0" + minutes : minutes;
                    seconds = seconds < 10 ? "0" + seconds : seconds;

                    display.textContent = minutes + ":" + seconds;

                    if (--timer < 0) {
                        timer = duration;
                    } else if (timer == 0) {
            
                    this.$alert(this.$t("common.timeup"))
                    .then(
                        () => {
                        window.location.href = this.IAkaunUrl 
                    });
                }
            }, 1000);
        },
        Confirmed:function(){
            
            this.userAlert = false
        },
        onSubmit(){
            this.$q.loading.show({
                spinnerSize: 50
            }), 
            this.CIFAccountInformationUpdate()
            .then(res => {

                this.$store.dispatch('Logging',{
                    appid : '2',
                    typeid :'4', 
                    str : 'Application ID --> ' + this.StoreStateLogin.incomingAppID + ' CIFAccountInformationUpdate (buy),  res - > '+  res
                });

                if(res == true){
                    this.requestUpdateAlert = false;
                    location.reload()
                    this.$q.loading.hide()
                }else{
                this.$q.dialog({
                    title: 'Error',
                    message: 'Sorry, unable to update your info. Please contact our Customer Support to assist you on this'
                })
                this.$q.loading.hide()
                }

            })
        }
        
  },
  computed: {

  }
}
</script>